export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 130 },
  { key: '2', headerName: 'GL Account Number', field: 'gl_code', hide: false, width: 400 },
  { key: '3', headerName: 'GL Description', field: 'gl_description', hide: false, width: 400 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 200 }
];